import { Box, Typography } from "@drone-js/core";
import type { FunctionComponent } from "react";
import BrandList from "./BrandList";
import { PartnerMarketingLayout } from "./PartnerMarketingLayout";
import { usePartnerMarketingModelValue } from "./partnerMarketingModelAtom";

export const FooterBottom: FunctionComponent = () => {
    const { agodaCopyrightText, parentCopyrightText } = usePartnerMarketingModelValue();

    const serverName = document.querySelector("span#serverName").textContent;

    return (
        <footer id="footer-section" className="main-footer-bottom">
            <Box backgroundColor="base.surface.floating.inverted" py="48">
                <PartnerMarketingLayout col={10} data-element-name="footer-section">
                    <Box as="span" qM={{ mb: "4" }}>
                        <Typography variant="body-s" textAlign="center" textColor="base.inverted.subtle">
                            {agodaCopyrightText}
                        </Typography>
                    </Box>
                    <Box as="span" display="none" qM={{ display: "block" }} qL={{ mb: "24" }}>
                        <Typography variant="body-s" textAlign="center" textColor="base.inverted.subtle">
                            {parentCopyrightText}
                        </Typography>
                    </Box>

                    <Box display="none" qL={{ display: "block" }} my="48">
                        <BrandList />
                    </Box>

                    <Box textAlign="center" mt="24">
                        <Typography textColor="base.disabled" variant="caption-default">
                            {serverName}
                        </Typography>
                    </Box>
                </PartnerMarketingLayout>
            </Box>
        </footer>
    );
};
